// ApiFetch.js
export const fetchCaractPromises = (itemIds) => {
    if (!itemIds) {
        return Promise.resolve([]);
    }
    const promises = itemIds.map((itemId) => {
        return fetch(`https://api.dofusdu.de/dofus2/fr/items/equipment/${itemId}`).then((response) => response.json());
    });
    return Promise.all(promises);
};

export const fetchData = (setApiData, setApiDataCaract, minLvl, maxLvl, itemType) => {
    const url = `https://api.dofusdu.de/dofus2/en/items/equipment?sort%5Blevel%5D=desc&filter%5Btype_name%5D=${itemType}&filter%5Bmin_level%5D=${minLvl}&filter%5Bmax_level%5D=${maxLvl}&page%5Bsize%5D=-1&page%5Bnumber%5D=1&fields%5Bitem%5D=parent_set`;
    console.log("test1", minLvl, typeof minLvl);
    console.log("test2", maxLvl, typeof maxLvl);
  
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erreur lors de la récupération des données');
        }
        return response.json();
      })
      .then((data) => {
        console.log("Data from API:", data);
        setApiData(data.items);
        return fetchCaractPromises(data.items.map((item) => item.ankama_id));
      })
      .then((dataCaracts) => {
        console.log(dataCaracts);
        setApiDataCaract(dataCaracts);
      })
      .catch((error) => {
        console.error('Erreur lors de la récupération des données :', error);
      });
  };
